import {
    GET_SALESORDER_REQUEST, GET_SALESORDER_SUCCESS, GET_SALESORDER_FAIL,
    CREATE_SALESORDER_REQUEST, CREATE_SALESORDER_SUCCESS, CREATE_SALESORDER_FAIL,
    UPDATE_SALESORDER_REQUEST, UPDATE_SALESORDER_SUCCESS, UPDATE_SALESORDER_FAIL,
    DELETE_SALESORDER_REQUEST, DELETE_SALESORDER_SUCCESS, DELETE_SALESORDER_FAIL,
    GET_CUSTOMERSALESORDER_REQUEST, GET_CUSTOMERSALESORDER_SUCCESS, GET_CUSTOMERSALESORDER_FAIL,
    GENERATE_PDF_REQUEST, GENERATE_PDF_SUCCESS, GENERATE_PDF_FAIL,
    ADD_SELECTED_INVOICE, REMOVE_SELECTED_INVOICE, ADD_MULTI_SELECTED_INVOICE,
    REMOVE_MULTI_SELECTED_INVOICE, CLEAR_SELECTED_INVOICE
} from "../types/salesOrderTypes";

function generatePdfReducer(state = { generatePdf: {}, allCheckData: [], allSoIds: [] }, action) {
    switch (action.type) {
        case GENERATE_PDF_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GENERATE_PDF_SUCCESS:
            return {
                ...state,
                generatePdf: action.payload,
                isLoading: false
            }
        case GENERATE_PDF_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }

        case ADD_SELECTED_INVOICE:
            const data = state.allCheckData.filter((item) =>
                item.soId == action.payload.soId || item.sales_orders_id == action.payload.soId
            )
            if (data.length > 0) {
                const data = state.allCheckData.filter((item) => item.soId != action.payload.soId && item.sales_orders_id != action.payload.soId)
                const idsData = state.allSoIds.filter((soId) => soId != action.payload.soId)

                return {
                    ...state,
                    allCheckData: data,
                    allSoIds: idsData
                }
            } else {
                return {
                    ...state,
                    allCheckData: [...state.allCheckData, action.payload],
                    allSoIds: [...state.allSoIds, action.payload.soId]
                }
            }

        case REMOVE_SELECTED_INVOICE:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }


        case ADD_MULTI_SELECTED_INVOICE:
            const ids = []
            action.payload.map(({ sales_orders_id }) => {
                ids.push(sales_orders_id)
            })
            return {
                ...state,
                allCheckData: action.payload,
                allSoIds: ids
            }

        case REMOVE_MULTI_SELECTED_INVOICE:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }

        case CLEAR_SELECTED_INVOICE:
            return {
                ...state,
                allCheckData: [],
                allSoIds: []
            }

        default:
            return state;
    }
}


function deleteSalesOrderReducer(state = { deleteSalesOrder: {} }, action) {
    switch (action.type) {
        case DELETE_SALESORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_SALESORDER_SUCCESS:
            return {
                ...state,
                deleteSalesOrder: action.payload,
                isLoading: false
            }
        case DELETE_SALESORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updateSalesOrderReducer(state = { updateSalesOrder: {} }, action) {
    switch (action.type) {
        case UPDATE_SALESORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_SALESORDER_SUCCESS:
            return {
                ...state,
                updateSalesOrder: action.payload,
                isLoading: false
            }
        case UPDATE_SALESORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function createSalesOrderReducer(state = { createSalesOrder: {} }, action) {
    switch (action.type) {
        case CREATE_SALESORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_SALESORDER_SUCCESS:
            return {
                ...state,
                createSalesOrder: action.payload,
                isLoading: false
            }
        case CREATE_SALESORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getSalesOrderReducer(state = { salesOrder: [] }, action) {
    switch (action.type) {
        case GET_SALESORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_SALESORDER_SUCCESS:
            return {
                ...state,
                salesOrder: action.payload,
                isLoading: false
            }
        case GET_SALESORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


function getCustomerSalesOrderReducer(state = { customerSalesOrder: [] }, action) {
    switch (action.type) {
        case GET_CUSTOMERSALESORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_CUSTOMERSALESORDER_SUCCESS:
            return {
                ...state,
                customerSalesOrder: action.payload,
                isLoading: false
            }
        case GET_CUSTOMERSALESORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

export { getSalesOrderReducer, createSalesOrderReducer, updateSalesOrderReducer, deleteSalesOrderReducer, getCustomerSalesOrderReducer, generatePdfReducer }